import type { IScopeElementStatus } from '@app/types';

export function isScopeElementStatusComplete(
  scopeElementStatusId: string | null,
  scopeElementStatuses: IScopeElementStatus[]
) {
  return scopeElementStatuses.find((status) => status.id === scopeElementStatusId)?.isComplete ?? false;
}
